/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DayTemplate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DayTemplate({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DateAndMetrics/DayTemplate"
  
}) {
let calendarDayTemplateColorValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'template_color',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let calendarDayTemplateNameValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'template_name',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="DayTemplate.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-ZvutXN': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-2-ZvutXN': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-3-ZvutXN': calendarDayTemplateColorValueData}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceMs}
 color={dtColorsNeutral900}
 size="small"
 data="calendar_day.template_name"
 text={calendarDayTemplateNameValueData}
/>
{children}
</React.Fragment>)
}